/* Core & libraries */
import * as React from 'react';
import { useTheme } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {useEffect} from "react";

/* Helpers, constants, custom methods, internal libraries */
import { ROOT_PATH } from '../../constants/routes';
import { useAnalytics } from "../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../constants/appConstants";

/* Components */
import UCButton from '../../components/buttons';

/* Styles */
import styles from './styles.js';
import generalStyles from '../../resources/styles/general';


const ErrorPage = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const general = generalStyles({ theme });
  const navigate = useNavigate();
  const { initAnalytics } = useAnalytics();

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["errorPage"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  return (
    <div className={general.main}>
      <div className={classes.notFoundContainer}>
        <span className={classes.error}>
          <FormattedMessage id='errorPage.error' />
        </span>
        <h1>
          <FormattedMessage id='errorPage.title' />
        </h1>
        <p>
          <FormattedMessage id='errorPage.description' />
        </p>
        <div className={classes.btnContainer}>
          <UCButton
            onClick={() => navigate(ROOT_PATH)}
            type='primary'
            className={classes.homeBtn}
            text={
              <div>
                <FormattedMessage id='errorPage.homeBtn' />
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
